export enum ActionTypes {
  CREATE_PROGRAM_GOAL_TARGET_REQUEST = "@@program_goal_target/CREATE_PROGRAM_GOAL_TARGET_REQUEST",
  CREATE_PROGRAM_GOAL_TARGET_SUCCESS = "@@program_goal_target/CREATE_PROGRAM_GOAL_TARGET_SUCCESS",
  CREATE_PROGRAM_GOAL_TARGET_FAILURE = "@@program_goal_target/CREATE_PROGRAM_GOAL_TARGET_FAILURE",

  DELETE_PROGRAM_GOAL_TARGET_REQUEST = "@@program_goal_target/DELETE_PROGRAM_GOAL_TARGET_REQUEST",
  DELETE_PROGRAM_GOAL_TARGET_SUCCESS = "@@program_goal_target/DELETE_PROGRAM_GOAL_TARGET_SUCCESS",
  DELETE_PROGRAM_GOAL_TARGET_FAILURE = "@@program_goal_target/DELETE_PROGRAM_GOAL_TARGET_FAILURE",
}
